/**
 * Helper: Format money
 * -----------------------------------------------------------------------------
 * Formats money into store format.
 *
 * @param {Number} value - Value in cents.
 * @param {String} format - Money format.
 * @returns {String}
 *
 */
import { formatMoney } from '@we-make-websites/theme-currency'
import { getMoneyFormat } from '~/helpers/general'

export default (value, format) => {
  const preferredFormat = format ? format : getMoneyFormat(value)
  let money = String(value).endsWith('00')
    ? formatMoney(value, preferredFormat)
    : formatMoney(value, cnvs.store.moneyFormat)

  const countriesToShowCurrency = cnvs.metafields?.shop?.countriesToShowCurrency || []
  const country = cnvs.store.country.toLowerCase()
  if (
    countriesToShowCurrency.includes(country) &&
    !money.includes(cnvs.store.currency)
  ) {
    money = `${cnvs.store.currency} ${money}`
  }

  return typeof money === 'string' ? money.trim() : money
}
